import { Component } from '@angular/core';
import { Router ,ActivatedRoute} from '@angular/router';
import {BookingListService} from '../../services/booking-list.service'
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-booking-menu-list',
  templateUrl: './booking-menu-list.component.html',
  styleUrls: ['./booking-menu-list.component.css']
})
export class BookingMenuListComponent {
  image="../../../assets/images/B2CHeaderSprite.png"
imagePieces:any
imageBase64: string | null = null;

  constructor(private data:DataService,private router: Router,private route: ActivatedRoute,private BookingListService:BookingListService) {
    let image:any
    var myImage = new Image();

    // Set the source (URL) of the image
    myImage.src = this.image;
    this.imagePieces=this.BookingListService.imagePieces()

   
    
  }

  isActive(route: string): boolean {
    return this.router.isActive(route, true);
  }

// imagePieces: string[] = [];

// onImageSelected(event: any): void {
//   // console.log(event.target.files[0])

//   // const file = event.target.files[0];

//   // if (file) {
//   //   const reader = new FileReader();
//   //   reader.onload = (e: any) => {
//       // this.imageBase64 = e.target.result;
       
      
//       this.splitImage();
//   //   };
//   //   reader.readAsDataURL(file);
//   // }
// }
// splitImage(): void {
//   // Split the image into smaller pieces (adjust the dimensions as needed)
//   const img = new Image();
//   img.onload = () => {
//     const pieceWidth = 95;
//     const pieceHeight = 80;
    
//     // for (let x = 0; x < img.width; x += pieceWidth) {
//     //   for (let y = 0; y < img.height; y += pieceHeight) {
//     //     const canvas = document.createElement('canvas');
//     //     const context:any = canvas.getContext('2d');
//     //     canvas.width = pieceWidth;
//     //     canvas.height = pieceHeight;

//     //     context.drawImage(img, x, y, pieceWidth, pieceHeight, 0, 0, pieceWidth, pieceHeight);

//     //     const pieceBase64Code = canvas.toDataURL();
//     //     console.log(pieceBase64Code)
//     //     this.imagePieces.push(pieceBase64Code);
//     //     console.log(this.imagePieces)

//     //   }
//     // }
//   };
//   img.src = this.imageBase64!;
// }

OnClickFlight(){
    this.router.navigate(["/app/flight"]);
    this.data.deliverMsg('default message')

}
OnClickHotel(){
  this.router.navigate(["/app/hotel"]);
  this.data.deliverMsg('default message')


}

OnClickInsurance(){
  this.router.navigate(["/app/insurance"]);
  this.data.deliverMsg('default message')
}

OnClickCab(){
  window.location.href='https://main.d3kcvm5gcaoio8.amplifyapp.com/search'
}
}

